// One audio element, unlocked on the user's first tap and reused everywhere.
// iOS blocks a fresh `new Audio()` that starts after an await, which cut her voice off.
const SILENT = "data:audio/wav;base64,UklGRiQAAABXQVZFZm10IBAAAAABAAEAQB8AAEAfAAABAAgAZGF0YQAAAAA=";
let el = null;
let unlocked = false;

export function getPlayer() {
  if (!el && typeof Audio !== "undefined") { el = new Audio(); el.preload = "auto"; el.setAttribute("playsinline", ""); }
  return el;
}

function unlock() {
  const p = getPlayer();
  if (!p || unlocked) return;
  if (p.src && !p.paused) { unlocked = true; return; }
  p.src = SILENT;
  p.play().then(() => { unlocked = true; try { p.pause(); } catch (e) {} }).catch(() => {});
}

if (typeof window !== "undefined") {
  ["pointerdown", "touchend", "keydown"].forEach((ev) => window.addEventListener(ev, unlock, { capture: true, passive: true }));
}

export function stopAudio() {
  const p = getPlayer();
  if (!p) return;
  try { p.pause(); } catch (e) {}
  p.onended = p.ontimeupdate = p.onerror = null;
}

export function playUrl(url, { onEnded, onTime } = {}) {
  const p = getPlayer();
  stopAudio();
  p.src = url;
  p.onended = () => onEnded && onEnded();
  if (onTime) p.ontimeupdate = () => onTime(p);
  return p.play().then(() => p);
}
